import React from 'react';

import { useRecordContext, SelectField } from 'react-admin';

import { get } from 'lodash';

import { Grid, Box, Typography } from '@mui/material';

import Answer from '../Answer';

import booleanChoices from '../../../../constants/booleanChoices';
import languages, { Languages } from '../../../../constants/languages';
import { BooleanQuestionParameters } from '../../questionParameters';
import applyChoices from '../../applyChoices';

const TITLE = {
  [languages.SV]: 'Äger personen företaget/organisationen tillsammans med en eller flera familjemedlemmar?',
  [languages.EN]: 'Does the person control or own the company/organization together with one or more close relatives?',
  [languages.DE]: 'Kontrolliert oder besitzt die Person das Unternehmen/die Organisation zusammen mit einer oder mehreren nahen Angehörigen?',
};

const ValueField = ({
  language,
  extraParameters,
}: {
  language?: Languages;
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return <Typography>-</Typography>;

  return (
    <SelectField
      choices={applyChoices(
        booleanChoices[language],
        extraParameters?.options,
        extraParameters?.choiceLabels,
      )}
      record={{ value }}
      sx={sx}
      source="value"
      emptyText="-"
      fontWeight="bold"
    />
  );
};

const FamilyControl = ({
  source,
  extraParameters,
}: {
  source?: string;
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? TITLE[language]}
      source={source ?? 'familyControl'}
      datapoint={null}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>

  );
};

FamilyControl.ValueField = ValueField;

FamilyControl.Nested = ({ source, extraParameters }: {
  source?: string;
  extraParameters?: BooleanQuestionParameters;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const record = useRecordContext();
  const sx = get(record, 'sx', {});

  const language = record?.language as Languages;

  return (
    <Grid
      size={{
        xs: 12,
        md: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="label">{extraParameters?.label ?? TITLE[language]}</Typography>
        <SelectField
          choices={applyChoices(
            booleanChoices[language],
            extraParameters?.options,
            extraParameters?.choiceLabels,
          )}
          source={source ?? 'familyControl'}
          emptyText="-"
          sx={sx}
        />
      </Box>
    </Grid>
  );
};

export default FamilyControl;
